import { errorHttpMessage } from "@/utils/errorDecodeUtil"
import catalogsClient from '@/axiosClients/catalogsClient'

export const getCatalogLocalities = async ({ commit }, search = '') => {
    try {
        const { data: result } = await catalogsClient.get(`/localities-catalog?search=${encodeURIComponent(search)}`)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}

export const getFederalEntities = async ({ commit }) => {
    try {
        const { data: result } = await catalogsClient.get(`/federal-entities/dropdown`)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}

export const getMunicipalitiesByEntity = async ({ commit }, federalEntityCode) => {
    try {
        const { data: result } = await catalogsClient.get(`/municipalities/dropdown/${federalEntityCode}`)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}

export const storeCatalogLocality = async ({ commit }, payload) => {
    try {
        const { data: result } = await catalogsClient.post(`/localities-catalog`, payload)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}
